import { keyBy } from 'lodash';

export function selectedCustomCardId(state) {
  return state.selectedCustomCardId;
}

export function customCardList(state) {
  return state.customCardList;
}

export function customCards(state) {
  return keyBy(state.customCardList, card => card.id);
}

export function customCardIds(state) {
  return state.customCardList.map(card => (card.id));
}



// WEBPACK FOOTER //
// ./src/app/custom-cards/store/getters.js